import * as React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Footer } from './components';
import { PrivateRoute } from './components/PrivateRoute';
import { AuthContextProvider } from './context';
import {
  AdminHome,
  AdminSignIn,
  InvigilatorHome,
  LandingPage,
  NotFoundPage,
  StudentHome,
} from './pages';

function App(): JSX.Element {
  React.useEffect(() => {
    return;
  }, []);
  return (
    <Router>
      <AuthContextProvider>
        <Routes>
          <Route path="/" element={<LandingPage />} />

          {/* These should be protected routes */}
          <Route
            path="/student"
            element={
              <PrivateRoute user="student" redirect="/">
                <StudentHome />
              </PrivateRoute>
            }
          />
          <Route
            path="/invigilator"
            element={
              <PrivateRoute user="invigilator" redirect="/">
                <InvigilatorHome />
              </PrivateRoute>
            }
          />
          <Route path="/admin">
            <Route
              path="home"
              element={
                <PrivateRoute user="admin" redirect="/admin/sign-in">
                  <AdminHome />
                </PrivateRoute>
              }
            />
            <Route path="sign-in" element={<AdminSignIn />} />
          </Route>

          {/* For all the routes that are not found - 404 pages */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
        <Footer />
      </AuthContextProvider>
      <ToastContainer />
    </Router>
  );
}

export default App;
